const SEO = [
	{
		page: "home",
		description:
			"I am into software development, architecting scalable solutions, and writing concise code. Tough problems motivate me. Through college and work experience, I co-developed several software systems using diverse technologies like C#, Java, ASP.NET, AWS, Docker, GitHub, and relational databases.",
		keywords: ["Umid", "Umidjon", "Umid Muzrapov", "Muzrapov", "Umid M"],
	},

	{
		page: "about",
		description:
			"I am a Computer Science and Mathematics major at the University of Arizona. I have taken courses on software engineering, algorithms, database design and mathematical analysis. I work part-time as a software developer on campus, where I created the system to track chemical sprays across the campus and contributed to other critical projects. ",
		keywords: ["Umid", "Umidjon", "Umid Muzrapov", "Muzrapov", "Umid M"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Umid", "Umidjon", "Umid Muzrapov", "Muzrapov", "Umid M"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Umid", "Umidjon", "Umid Muzrapov", "Muzrapov", "Umid M"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Umid", "Umidjon", "Umid Muzrapov", "Muzrapov", "Umid M"],
	},
];

export default SEO;
